import React, { Component } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import ShellLayout from "./layouts/ShellLayout";
import DefaultLayout from "./layouts/default";

import Login from "./pages/login";
import Information from "./pages/InformationHook";
import DesignAsset from "./pages/DesignAssetHook";
import DesignProgram from "./pages/DesignProgramHook";
import Deploy from "./pages/DeployHook";
import NoPage from "./pages/404";
import ProjectHome from "./pages/project";
import AuthCallback from "./auth/AuthCallback";
import UserRegistration from "./pages/userRegistration";
import auth from "./auth/Auth";
import Logout from "./pages/logout";
import SystemPage from "./pages/SystemPageHook";
import Systems from "./pages/Systems";
import RegistrationLayout from "./layouts/registrationLayout";
import cancelInvitation from "./pages/cancel";
import Invitation from "./pages/invitation";
import NonRegistered from "./pages/nonregistered";
import UserProfile from "./pages/userProfile";
import BOM from "./pages/bom"
import TermsAndConditions from "./pages/TermsAndConditions";
import SecureArchitectureHook from "./pages/SecureArchitectureHook";
import MyErrorBoundary from "./utils/ErrorBoundary";
import CheckApiHealth from "./utils/checkApiHealth";
import withSessionStorage from "./pages/CustomHooks/withSessionStorage";

const authLogin = new auth();

export const AppRoute = ({
  component: Component,
  layout: Layout,
  auth: Auth,
  ...rest
}) =>
  Auth === "yes" ? (
    authLogin?.isAuthenticated() === true ? (
      <Route
        {...rest}
        render={(routeProps) => (
          <Layout>
            <Component {...routeProps} />
          </Layout>
        )}
      />
    ) : (
      <Route
        {...rest}
        render={(routeProps) => (
          <Layout>
            <Login {...routeProps} />
          </Layout>
        )}
      />
    )
  ) : (
    <Route
      {...rest}
      render={(routeProps) => (
        <Layout>
          <Component {...routeProps} />
        </Layout>
      )}
    />
  );

class App extends Component {
  componentDidMount() {
    // Add GTM script once
    const script = document.createElement("script");
    script.textContent = `
      ;(function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-P5LK2FC6');
    `;
    document.head.appendChild(script);
  }

  render() {
    const redirectPaths = [ "/program" ,"/deploy", "/assets", "/systems","/bom"];
    return (
      <se-app theme="light">
        <BrowserRouter>
          <Switch>
            <AppRoute
              exact
              path="/"
              layout={ShellLayout}
              component={Login}
              auth={"no"}
            />
            <AppRoute
              path="/callback"
              layout={DefaultLayout}
              component={AuthCallback}
              auth={"no"}
            />
            <AppRoute
              path="/deploy/:projectId"
              layout={ShellLayout}
              component={Deploy}
              auth={"yes"}
            />

            <AppRoute
              path="/information/new"
              layout={ShellLayout}
              component={Information}
              auth={"yes"}
            />

            <AppRoute
              path="/information/:projectId"
              layout={ShellLayout}
              component={withSessionStorage(Information, "projectId")}
              auth={"yes"}
            />

            <AppRoute
              path="/assets/:projectId"
              layout={ShellLayout}
              component={withSessionStorage(DesignAsset, "projectId")}
              auth={"yes"}
            />

            <AppRoute
              path="/program/:projectId"
              layout={ShellLayout}
              component={withSessionStorage(DesignProgram, "projectId")}
              auth={"yes"}
            />
            <AppRoute
              path="/systems/:projectId"
              layout={ShellLayout}
              component={withSessionStorage(Systems, "projectId")}
              auth={"yes"}
            />
            <AppRoute
              path="/bom/:projectId"
              layout={ShellLayout}
              component={withSessionStorage(BOM, "projectId")}
              auth={"yes"}
            />
            <AppRoute
              path="/system"
              layout={ShellLayout}
              component={SystemPage}
              auth={"yes"}
            />
            <AppRoute
              exact="true"
              path="/project"
              layout={ShellLayout}
              component={ProjectHome}
              auth={"yes"}
            />
            <AppRoute
              path="/logout"
              layout={ShellLayout}
              component={Logout}
              auth={"no"}
            />
            <AppRoute
              path="/registration"
              layout={RegistrationLayout}
              component={UserRegistration}
              auth={"no"}
            />
            <AppRoute
              path="/invitation"
              layout={RegistrationLayout}
              component={Invitation}
              auth={"no"}
            />
            <AppRoute
              path="/cancel"
              layout={RegistrationLayout}
              component={cancelInvitation}
              auth={"no"}
            />
            <AppRoute
              path="/nonregistered"
              layout={RegistrationLayout}
              component={NonRegistered}
              auth={"no"}
            />
            <AppRoute
              path="/userdetails"
              layout={ShellLayout}
              component={UserProfile}
              auth={"yes"}
            />

            <AppRoute
              path="/secureArchitecture"
              layout={ShellLayout}
              component={SecureArchitectureHook}
              auth={"yes"}
            />
            <Route
              path="/TermsAndConditions"
              render={(routeProps) => <TermsAndConditions {...routeProps} />}
            />
            <Route
              path="/health"
              render={(routeProps) => <CheckApiHealth {...routeProps} />}
            />
            {redirectPaths.map((path) => (
              <Route key={path} path={path}>
                <Redirect to="/project" />
              </Route>
            ))}
            <AppRoute
              path="/*"
              layout={DefaultLayout}
              component={NoPage}
              auth={"no"}
            />
          </Switch>
        </BrowserRouter>
      </se-app>
    );
  }
}

export default App;
